import axios from "axios";
import store from "../store";

export default () => {
  return axios.create({
    baseURL:
      // process.env.NODE_ENV === "development"
        // ?
         "https://agents.balkan1936.co.il/api/agent",
        // : "https://agents.balkan1936.co.il/api/agent",
    headers: {
      Authorization: `Bearer ${store.state.AuthModule.token}`,
      "Cache-Control": "no-cache",
    },
  });
};
